// Dealer pricing + profit math for the concept site.
// !! PLACEHOLDER NUMBERS !!  Replace with AdminTuning's real dealer pricing.
// On Shopify, real dealer prices live in the product metafield custom.dealer_price (see MIGRATION.md)
// and are only rendered for logged-in customers tagged "dealer".
window.AT_DEALER = {
  placeholder: true,
  // first matching rule wins; pct = % off retail
  rules: [
    { test: h => /retune|remote-tun|tuning-kit|transmission-tune|traction-control/.test(h), pct: 20, label: "Tuning" },
    { test: h => /performance-package|engine-packages|600whp-package/.test(h), pct: 10, label: "Packages" },
    { test: h => /turbo|boosted-performance|trp800/.test(h), pct: 8, label: "Turbo kits" },
    { test: h => /merch|t-shirt|license-plate/.test(h), pct: 25, label: "Merch" }
  ],
  defaultPct: 12,
  overrides: {
    // "product-handle": 499.00   ← exact dealer price, wins over rules
  },
  price(handle, retail) {
    if (this.overrides[handle] != null) return { price: this.overrides[handle], pct: Math.round((1 - this.overrides[handle] / retail) * 100) };
    const r = this.rules.find(x => x.test(handle));
    const pct = r ? r.pct : this.defaultPct;
    return { price: Math.round(retail * (100 - pct)) / 100, pct };
  },

  // ---- profit ----
  // "Tuning" = tunes, retunes, transmission tunes, traction control, ECU services. Everything else = "Parts".
  kind: h => (/retune|remote-tun|tuning-kit|transmission-tune|traction-control|tune-migration/.test(h) ? "tuning" : "parts"),
  // What the dealer charges their customer, as % of AdminTuning retail (dealer setting, default 100 %).
  resalePct() { try { const v = +localStorage.getItem("at_dealer_resale"); return v > 0 ? v : 100; } catch (e) { return 100; } },
  setResalePct(v) { try { localStorage.setItem("at_dealer_resale", String(v)); } catch (e) {} },
  // One line: unit retail, unit dealer cost, qty → resale, cost, profit
  line(handle, retail, qty, cost) {
    const unitCost = cost != null ? cost : this.price(handle, retail).price;
    const resale = Math.round(retail * this.resalePct()) / 100;
    return { kind: this.kind(handle), qty, cost: unitCost * qty, resale: resale * qty, profit: (resale - unitCost) * qty };
  }
};
